import { useEffect } from 'react';
import { Form, Modal, Select, App } from 'antd';
import { 
    useEditAccountInvoiceBillingCycleMutation,
} from '../../features/api/apiSlice';
function EditBillingCycleModal ({ open, setOpen, data }) {

    const [form] = Form.useForm();
    const [editAccountInvoiceBillingCycle, {
        isLoading: editAccountInvoiceBillingCycleLoading,
        error: editAccountInvoiceBillingCycleError,
        isSuccess: editAccountInvoiceBillingCycleIsSuccess,
        isError: editAccountInvoiceBillingCycleIsError,
    }] = useEditAccountInvoiceBillingCycleMutation();
    const { notification } = App.useApp();
    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                billing_cycle: data.billing_cycle,
            });
        }
    }, [data])
    useEffect(() => {
        if (editAccountInvoiceBillingCycleIsSuccess) {
            notification.success({
                message: '成功',
                description: '账期修改成功',
            });
            setOpen(false);
        }
        if (editAccountInvoiceBillingCycleIsError) {
            notification.error({
                message: '失败',
                description: editAccountInvoiceBillingCycleError?.data?.error || '账期修改失败',
            });
        }
    }, [editAccountInvoiceBillingCycleIsSuccess, editAccountInvoiceBillingCycleIsError]);
    const modalOkHandler = () => {
        form.validateFields().then((values) => {
            const formData = new FormData();
            formData.append('billing_cycle', values.billing_cycle);
            formData.append('account_invoice_id', data.id);
            editAccountInvoiceBillingCycle(formData);
        }).catch((info) => {
            console.log('Validate Failed:', info);
        });
    };

    return (
        <Modal
            title="帐期修改"
            open={open}
            onCancel={() => setOpen(false)}
            onOk={modalOkHandler}
            confirmLoading={editAccountInvoiceBillingCycleLoading}
        >
            <Form
                form={form}
                labelCol={{
                    span: 5,
                }}
                wrapperCol={{
                    span: 19,
                }}
                style={{
                    marginTop: '20px',
                    marginLeft: '0%',
                    marginRight: '10%',
                    maxWidth: '100%'
                }}
            >
                <Form.Item label="账期" name='billing_cycle' rules={[{ required: true, message: '请选择账期!' }]}>
                    <Select
                        style={{ width: '90%' }}
                    >
                        <Select.Option value="0">0 天</Select.Option>
                        <Select.Option value="7">7 天</Select.Option>
                        <Select.Option value="15">15 天</Select.Option>
                        <Select.Option value="25">25 天</Select.Option>
                        <Select.Option value="30">30 天</Select.Option>
                        <Select.Option value="60">60 天</Select.Option>
                        <Select.Option value="90">90 天</Select.Option>
                        <Select.Option value="预充">预充</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default EditBillingCycleModal;